import { Picker, Section, Period, Durations, Portal, Timeslots, FulfillmentTypeSelect, Error, PeriodReset } from './styles'

Picker.Section = Section
Picker.Period = Period
Picker.Durations = Durations
Picker.Timeslots = Timeslots
Picker.Portal = Portal
Picker.FulfillmentTypeSelect = FulfillmentTypeSelect
Picker.Error = Error
Picker.PeriodReset = PeriodReset

export default Picker
